export default "__VITE_ASSET__aIxg6gth__"